import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface AddMainPageGroupPayload {
  locationId: string;
  groupName: string;
  description: string;
}

export interface UpdateMainPageGroupPayload {
  groupId: string;
  groupName: string;
  description: string;
}

export interface DeleteMainPageGroupPayload {
  groupId: string;
}

export interface UpdateMainPageShufflePayload {
  setShuffleTime1: number;
  setShuffleTime2: number;
  groupShuffle: number;
}

const addMainPageGroup = (client: AxiosInstance) => async (payload: AddMainPageGroupPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.CREATE_MAIN_PAGE_GROUP, payload)).data;
};

const updateMainPageGroup = (client: AxiosInstance) => async (payload: UpdateMainPageGroupPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.UPDATE_MAIN_PAGE_GROUP, payload)).data;
};

const deleteMainPageGroup = (client: AxiosInstance) => async (payload: DeleteMainPageGroupPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.DELETE_MAIN_PAGE_GROUP, payload)).data;
};

const updateMainPageShuffle = (client: AxiosInstance) => async (payload: UpdateMainPageShufflePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.UPDATE_MAIN_PAGE_SHUFFLE, payload)).data;
};

export const mainPageMutations = {
  addMainPageGroup,
  updateMainPageGroup,
  deleteMainPageGroup,
  updateMainPageShuffle,
};
